import { render, staticRenderFns } from "./upload-avatar-confirm-dialog.vue?vue&type=template&id=daf1506a&scoped=true&"
import script from "./upload-avatar-confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-avatar-confirm-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf1506a",
  null
  
)

export default component.exports